import { ArrowLeftCircle, Button, CopyIcon, Link as CsLink, Flex, Heading, IconSort, Text } from "@pancakeswap/uikit";
import ConnectWalletButton from "components/ConnectWalletButton";
import Container from "components/Layout/Container";
import PageFullWidth from "components/Layout/PageFullWidth";
import { UNIT_TOKEN } from "config";
import useActiveWeb3React from "hooks/useActiveWeb3React";
import { useRouter } from 'next/router';
import { useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { AppDispatch } from "state";
import { GetDataGiftCards } from "state/giftCards";
import NextLink from "next/link"
import { fetchActiveBrand, fetchActivePrice, fetchStatusScreen } from "state/giftCards/actions";
import styled from "styled-components";
import 'swiper/css';
import { getBlockExploreLink } from "utils";
import { formatNumber, formatNumberv2 } from "utils/formatNumber";
import { zeroPad } from "react-countdown";
import { fetTabActive } from "state/myvouchers/actions";
import { CsFlexLine, CsGiftCardInfoMobile, CsGiftCardInfoPC, CsHeading, RowItem, RowItemHeading } from "./styles";


const InformationOrder = () => {
    const router = useRouter()
    const { account } = useActiveWeb3React()
    const dispatch = useDispatch<AppDispatch>()
    
    const dataGiftcards = GetDataGiftCards()
    const { dataBuyVouchers, activeTokenPayment, tokenSupport, dataVouchers } = dataGiftcards
    const [isTooltipDisplayed, setIsTooltipDisplayed] = useState(false)
    const handleBack = (newValue:number) => {
        dispatch(fetchStatusScreen({isActiveScreen: newValue}))
    }

    const handleCoppy = () => {
        if (navigator.clipboard && navigator.permissions) {
            navigator.clipboard.writeText(dataBuyVouchers?.transactionHash).then(() => displayTooltipCode())
        } else if (document.queryCommandSupported('copy')) {
          const ele = document.createElement('textarea')
          ele.value = dataBuyVouchers?.transactionHash
          document.body.appendChild(ele)
          ele.select()
          document.execCommand('copy')
          document.body.removeChild(ele)
          displayTooltipCode()
        }
    }

    function displayTooltipCode() {
        setIsTooltipDisplayed(true)
        setTimeout(() => {
            setIsTooltipDisplayed(false)
        }, 3000)
    }

    const fotmatDate = (newDate:string) => {
        if(newDate?.length > 0) {
            const date = new Date(newDate)
            const month = date.getMonth() < 10 ? `0${date.getMonth()+1}` : date.getMonth()+1
            return `${zeroPad(date.getDate())}/${month}/${date.getFullYear()} ${zeroPad(date?.getHours())}:${zeroPad(date?.getMinutes())}`
        }
        return null
    }

    const sAccount = (txHash:string) => {
        if( txHash?.length > 0 ) {
            return `${txHash.substring(0, 4)}...${txHash.substring(txHash.length - 4)}`
        }
        return null
    }

    const handleClick = async () => {
        await dispatch(fetchStatusScreen({isActiveScreen: 0}))
        await dispatch(fetchActivePrice({price: null}))
        await dispatch(fetchActiveBrand({product: null}))
        await router?.push('/order')
    }
    const handleGoHistory = async () => {
        await dispatch(fetTabActive({tabActive: 2}))
        await router?.push("/myvoucher")
    }
    
    const findTokenPayment = useMemo(() => {
        return tokenSupport.find(
            (dt) => dt?.token?.address?.toLowerCase() === dataVouchers?.tokenPayment?.toLowerCase(),
        )
    }, [tokenSupport, dataVouchers?.tokenPayment])
    
    return (
        <>
            <PageFullWidth>
                <Container width="100%" mb="4rem">
                    <Flex width="100%" flexDirection="column" style={{gap:"1rem"}}>
                        <Flex width="100%">
                            <Flex alignItems="center" style={{gap:"12px", cursor:"pointer", width: 'fit-content'}} onClick={() => handleBack(0)}>
                                <ArrowLeftCircle width="32px" />
                                <Heading scale="lg">Quay lại</Heading>
                            </Flex>
                        </Flex>
                        <Flex width="100%" mt="1rem">
                            <Flex width="100%" justifyContent="center" alignItems="center" flexDirection='column'>
                                <CsHeading scale="xl">Thông tin đơn hàng</CsHeading>
                            </Flex>
                        </Flex>

                        <FlexInfoPersonReceipt width="100%" justifyContent="space-between" mt={["1rem", ,"3rem"]}>
                            <div style={{width: '100%'}}>
                                <Text fontWeight="bold" fontSize={['16px', , '20px']}>Thông tin người nhận quà</Text>
                                <CsWrapInfo width="100%" alignItems="flex-start" justifyContent="space-between" mt={['0.5rem', , ,"2rem"]}>
                                    <Flex width="100%" justifyContent="space-between">
                                        <Text color="default">Số điện thoại:</Text>
                                        <Text>{dataBuyVouchers?.phoneNo}</Text>
                                    </Flex>
                                    <Flex width="100%" justifyContent="space-between">
                                        <Text color="default">Email:</Text>
                                        <Text>{dataBuyVouchers?.email}</Text>
                                    </Flex>
                                </CsWrapInfo>
                            </div>

                            <div style={{width: '100%'}}>
                                <Text fontWeight="bold" fontSize={['16px', , '20px']}>Chi tiết đơn hàng</Text>
                                <CsGiftCardInfo2 mt={['0.5rem', , ,"2rem"]}>
                                    <CsFlexLine2>
                                        <CsTextFirst2 color="default">Mã đơn hàng:</CsTextFirst2>
                                        <CsText color="default">TXID:</CsText>
                                        <CsText color="default">Ngày giao dịch:</CsText>
                                        <CsTextLast color="default">Ngày hết hạn voucher:</CsTextLast>
                                    </CsFlexLine2>
                                    <CsFlexLine2Body>
                                        <CsTextFirst2>{dataBuyVouchers?.orderId}</CsTextFirst2>
                                        <Flex width="100%" justifyContent="flex-end" style={{ gap: '4px', position: 'relative'}} alignItems="center">
                                            <CsLink
                                                external
                                                href={getBlockExploreLink(dataBuyVouchers?.transactionHash, 'transaction', Number(dataBuyVouchers?.chainId))}
                                            >
                                                <CsText color="primary">
                                                    {sAccount(dataBuyVouchers?.transactionHash)}
                                                </CsText>
                                            </CsLink>
                                            <CsWrapIconCoppy onClick={handleCoppy}>
                                                <CopyIcon />
                                            </CsWrapIconCoppy>
                                            <Tooltip isTooltipDisplayed={isTooltipDisplayed}>Đã sao chép</Tooltip>
                                        </Flex>
                                        <CsText>{fotmatDate(dataBuyVouchers?.createdAt)}</CsText>
                                        <CsTextLast>{dataBuyVouchers?.itemExpired}</CsTextLast>
                                    </CsFlexLine2Body>
                                </CsGiftCardInfo2>
                            </div>
                        </FlexInfoPersonReceipt>

                        <Text mt="1rem" fontWeight="bold" fontSize={['16px', , '20px']}>Thông tin thẻ quà tặng</Text>
                        <CsGiftCardInfoPC>
                            <CsFlexLine>
                                <RowItemHeading isFirst color="default">Tên sản phẩm</RowItemHeading>
                                <RowItemHeading color="default">Số lượng</RowItemHeading>
                                <RowItemHeading color="default">Giá trị thẻ quà</RowItemHeading>
                                <RowItemHeading color="default">Tổng giá trị</RowItemHeading>
                            </CsFlexLine>
                            <CsFlexLine>
                                <RowItem isFirst>{dataBuyVouchers?.itemName}</RowItem>
                                <RowItem>{dataBuyVouchers?.quantity}</RowItem>
                                <RowItem>
                                    {/* {formatNumber(dataBuyVouchers?.unitPrice)}{UNIT_TOKEN} */}
                                    {
                                        dataBuyVouchers?.isPromo === 2 ?
                                        <>
                                            <Text>{Number(dataBuyVouchers?.promoPrice).toLocaleString("en",{minimumFractionDigits: 0, maximumFractionDigits: 0})}{UNIT_TOKEN}</Text>
                                            <Text style={{fontSize: '12px', textDecoration: 'line-through', color: '#9596a6'}}>{Number(dataBuyVouchers?.unitPrice).toLocaleString("en",{minimumFractionDigits: 0, maximumFractionDigits: 0})}{UNIT_TOKEN}</Text>
                                        </>
                                            :
                                        <>
                                            <Text>{Number(dataBuyVouchers?.unitPrice).toLocaleString("en",{minimumFractionDigits: 0, maximumFractionDigits: 0})}{UNIT_TOKEN}</Text>
                                        </>
                                    }
                                </RowItem>
                                <RowItem>
                                    {formatNumber(dataBuyVouchers?.totalAmount)}{UNIT_TOKEN}
                                    { findTokenPayment?.token?.symbol !== "VNDC" &&
                                        <Text style={{fontSize:"10px"}}>
                                            Tương đương {formatNumberv2(findTokenPayment?.exchangeRate, findTokenPayment?.token?.symbol) } điểm {findTokenPayment?.token?.symbol}
                                        </Text>
                                    }
                                </RowItem>
                            </CsFlexLine>
                        </CsGiftCardInfoPC>

                        <CsGiftCardInfoMobile>
                                <Flex alignItems="flex-end" justifyContent="space-between">
                                    <Text style={{whiteSpace: 'nowrap'}} color="default">Tên sản phẩm</Text>
                                    <Text textAlign="right">{dataBuyVouchers?.itemName}</Text>
                                </Flex>
                                <Flex alignItems="flex-end" justifyContent="space-between" mt="0.5rem">
                                    <Text color="default">Số lượng</Text>
                                    <Text textAlign="right">{dataBuyVouchers?.quantity}</Text>
                                </Flex>
                                <Flex alignItems="flex-end" justifyContent="space-between" mt="0.5rem">
                                    <Text color="default">Giá trị thẻ quà</Text>
                                    <Text textAlign="right">
                                        {/* {formatNumber(dataBuyVouchers?.unitPrice)}{UNIT_TOKEN} */}
                                        {
                                            dataBuyVouchers?.isPromo === 2 ?
                                            <>
                                                <Text>{Number(dataBuyVouchers?.promoPrice).toLocaleString("en",{minimumFractionDigits: 0, maximumFractionDigits: 0})}{UNIT_TOKEN}</Text>
                                                <Text style={{fontSize: '10px', textDecoration: 'line-through', color: '#9596a6'}}>{Number(dataBuyVouchers?.unitPrice).toLocaleString("en",{minimumFractionDigits: 0, maximumFractionDigits: 0})}{UNIT_TOKEN}</Text>
                                            </>
                                                :
                                            <>
                                                <Text>{Number(dataBuyVouchers?.unitPrice).toLocaleString("en",{minimumFractionDigits: 0, maximumFractionDigits: 0})}{UNIT_TOKEN}</Text>
                                            </>
                                        }
                                    </Text>
                                </Flex>

                                <Flex alignItems="flex-end" justifyContent="space-between" mt="0.5rem">
                                    <Text color="default">Tổng giá trị</Text>                                    
                                    <Flex flexDirection="column">
                                    <Text textAlign="right">{formatNumber(dataBuyVouchers?.totalAmount)}{UNIT_TOKEN}</Text>
                                    {findTokenPayment?.token?.symbol !== 'VNDC' && (
                                        <Text style={{ fontSize: '10px' }}>
                                            Tương đương{' '}
                                            {formatNumberv2(
                                                findTokenPayment?.exchangeRate,
                                                findTokenPayment?.token?.symbol,
                                            )}{' '}
                                            điểm {findTokenPayment?.token?.symbol}
                                        </Text>
                                    )}
                                </Flex>
                                </Flex>
                        </CsGiftCardInfoMobile>

                        <Flex minWidth="40%" justifyContent="center" alignItems="center" mt="2rem">
                            {!account ?
                                <ConnectWalletButton>
                                    Kết nối ví
                                    <IconSort ml='4px' color="white" style={{transform: 'rotate(270deg)'}} />
                                </ConnectWalletButton>
                            :
                                <Flex flexDirection="column" alignItems="center">
                                    <Flex onClick={handleGoHistory}>
                                       <CsTextNextLink> Lịch sử giao dịch</CsTextNextLink>
                                    </Flex>
                                    <CsButtonContinue mt="1rem" style={{cursor:"pointer"}} onClick={handleClick}>
                                        Tiếp tục đổi Voucher
                                        <IconSort ml='4px' color="white" style={{transform: 'rotate(270deg)'}} />
                                    </CsButtonContinue>
                                </Flex>
                            }
                        </Flex>          
                    </Flex>
                </Container>
            </PageFullWidth>
        </>
        
    )
}

const CsTextNextLink = styled(Text)`
    color: ${({ theme }) => theme.colors.primary};
    text-align: center;
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
    line-height: 26px;
    text-decoration-line: underline;
    cursor: pointer;
`
const CsButtonContinue = styled(Button)`
    border-radius: 4px;
`
const CsWrapInfo = styled(Flex)`
        gap: 10px;
        flex-direction: column;
        justify-content: flex-start;
        border: none;
        ${Text}{
            font-size: 14px;
        }
        @media screen and (max-width: 768px){
            padding: 1rem;
            border: 1px solid ${({theme}) => theme.colors.border};
            ${Text}{
                font-size: 12px;
            }
        }
`
const CsGiftCardInfo2 = styled(Flex)`
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    border-radius: 8px;
    border: none;
    @media screen and (max-width: 768px){
        padding: 1rem;
        border: 1px solid ${({theme}) => theme.colors.border};
    }
`

const CsFlexLine2 = styled(Flex)`
    justify-content: space-between;
    flex-direction: column;
    gap: 10px;
    ${Text}{
        font-size: 14px;
        @media screen and (max-width: 768px){
            font-size: 12px;
            text-align: left;
            justify-content: flex-start;
        }
    }
`

const CsFlexLine2Body = styled(Flex)`
    justify-content: space-between;
    flex-direction: column;
    gap: 10px;
    ${Text}{
        font-size: 14px;
        text-align: right;
        @media screen and (max-width: 768px){
            font-size: 12px;
            justify-content: flex-end;
        }
    }
`

const CsTextFirst2 = styled(Text)`
    text-align: left;
    width: 100%;
    @media screen and (max-width: 768px){
        width: 100%;
        text-align: right;
    }
`
const CsText = styled(Text)`
    white-space: nowrap;
    /* width: 20%; */
    @media screen and (max-width: 768px){
        width: 100%;
        text-align: right;
    }
`
const CsTextLast = styled(Text)`
    text-align: right;
    white-space: nowrap;
    @media screen and (max-width: 768px){
        text-align: right;
        width: 100%;
    }
`
const FlexInfoPersonReceipt = styled(Flex)`
        gap: 4rem;
        flex-direction: row;
        @media screen and (max-width: 768px){
            flex-direction: column;
            gap: 1rem;
            >div{
                margin-top: 1rem;
            }
        }
`
const CsWrapIconCoppy = styled.div`
    width: 34px;
    height: 34px;
    object-fit: contain;
    display: flex;
    justify-content: center;
    background: ${({theme}) => theme.colors.bgBtn};
    border-radius: 36.815px;
    cursor: pointer;
    @media screen and (max-width: 768px) {
        width: 28px;
        height: 28px;
        object-fit: contain;
        svg{
            width: 14px;
            height: 14px;
        }
    }
    &:active{
        transform: translateY(1px);
    }
`

const Tooltip = styled.div<{ isTooltipDisplayed: boolean }>`
    display: ${({ isTooltipDisplayed }) => (isTooltipDisplayed ? "block" : "none")};
    position: absolute;
    top:-34px;
    right: 0;
    text-align: center;
    color: ${({ theme }) => theme.colors.text};
    border-radius: 16px;
    opacity: 0.9;
    background: ${({theme}) => theme.colors.bgBtn};
    padding: 10px;
    z-index: 1;
    font-size: 12px;
`;

export default InformationOrder